import { render, staticRenderFns } from "./BeforeFlightDisclaimerModal.vue?vue&type=template&id=5795dbd3&scoped=true"
import script from "./BeforeFlightDisclaimerModal.vue?vue&type=script&lang=js"
export * from "./BeforeFlightDisclaimerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5795dbd3",
  null
  
)

export default component.exports